import {trackOmniture} from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';

export const PAGE_ID = {
  NEW_LANDING: "trainsnewlanding",
  LANDING: "trainslanding",
  LISTING: "trainslisting",
};

type TrackLanguageSwitch = {
  pageName: string;
  fromLang: string;
  toLang: string;
};

export const trackLanguageSwitch = ({
  pageName,
  fromLang,
  toLang,
}: TrackLanguageSwitch) => {
  const eventName = `${pageName}_header_${fromLang}_to_${toLang}_switched`;
  trackOmniture(pageName, {
    m_c67: eventName,
  });
};

